import { render, staticRenderFns } from "./custom-date.vue?vue&type=template&id=7c13fde6&scoped=true&"
import script from "./custom-date.vue?vue&type=script&lang=js&"
export * from "./custom-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c13fde6",
  null
  
)

export default component.exports